import React, { Component } from "react";
import { connect }          from "react-redux";
//MY COMPONENTS
import Menu                 from "../Components/component_Menu";
import Loader               from "../Components/component_Loader";
import ErrorMessage         from "../Components/component_MsgError";
//IMPORT COMPOENT UI
import Paper                from "material-ui/Paper";
import TextField            from "material-ui/TextField";
import FlatButton           from "material-ui/FlatButton";
import * as PAGESSWITCH     from "../Utils/PagesSwitch.js";
//ACTIONS 
import { convalidateToken, recoverSetPassword } from "../Actions/Action_ServiceRequest_RecuperaCredenziali";
//UTILS
import * as ROLES           from "../Utils/Roles_Types.js";
import { checkUserLanguage } from "../Utils/Check_Value";
//STYLES
import "../CSS/style_Login.css";
//LABELSs
import { LABEL_PasswordNew, LABEL_PasswordConfirm, LABEL_PasswordChange, LABEL_Enter_Password, LABEL_PasswordNotEquals, LABEL_PasswordModelError } from "../Utils/Strings/Labels";

const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE  = checkUserLanguage(USERINFO);

const styles = {
    pageContainer : {
        position       : "absolute",
        display        : "flex",
        alignItems     : "center",
        justifyContent : "center",
        height         : "100%",
        width          : "100%",
        flexDirection  : "column"
    },
    paper : {
        width: "40%",
        height : "40%",
        minWidth: "300px"
    },
    section : {
        width: "80%",
        margin: "auto",
        marginTop: "20px",
        marginBottom: "10px"
    },
    sectionFooter : {
        margin: "auto",
        marginTop: "50px",
    },
    message : {
        textAlign : "center",
        color : "red"
    }

}

class RecuperaPassword extends Component {
  constructor(props) {
    super(props);

    var params = PAGESSWITCH.locationSearchToParams(this.props.location.search)
    var token  = PAGESSWITCH.searchInParamsList("Token", params);
 
    if(token == null)
        PAGESSWITCH.gotoPageWithParams("/");

    this.state = {
        token : token,
        password : "",
        confirmPassword : ""
    };

  }

  onTextChange = (event, name) => this.setState( {[name]: event.target.value} );

  onClickSubmit = () => {
     var flag = true;

     if(this.state.password !== this.state.confirmPassword){
        this.state.pswError = LABEL_PasswordNotEquals[USERLANGUAGE];
        flag = false;
     }

     if( this.state.password.length < 2 ){
        this.state.pswError = LABEL_PasswordModelError[USERLANGUAGE];
        flag = false;
     }

     if(flag){
         this.setState({pswError : null})
        this.props.dispatch(recoverSetPassword(this.state.token, this.state.password, this.state.confirmPassword));
     }
        
  }

  componentDidMount(){
    //Convalido il token
    this.props.dispatch(convalidateToken(this.state.token));
  }

  render() {
    return <div>
        <ErrorMessage message={this.props.errorMessage} />
        <div style={styles.pageContainer} >
            <Paper zDepth={2} style={styles.paper}>
                    <section style={styles.section}>
                        <TextField className="input-label"
                          onChange={event => this.onTextChange(event, 'password')}
                          hintText={LABEL_Enter_Password[USERLANGUAGE]}
                          floatingLabelText={LABEL_PasswordNew[USERLANGUAGE]}
                          fullWidth={true}
                          type="password"
                          errorText={this.state.pswError} />
                    </section>
                    <section style={styles.section}>
                        <TextField className="input-label"
                          onChange={event => this.onTextChange(event, 'confirmPassword')}
                          hintText={LABEL_Enter_Password[USERLANGUAGE]}
                          floatingLabelText={LABEL_PasswordConfirm[USERLANGUAGE]}
                          fullWidth={true}
                          type="password"
                          errorText={this.state.pswError} />
                    </section>
                    <section style={styles.message}>
                        {this.props.errorMessage}
                    </section>
                    <section style={styles.sectionFooter}>
                        <button className="btn-login" onClick={this.onClickSubmit} >{LABEL_PasswordChange[USERLANGUAGE]}</button>
                    </section>
            </Paper>
        </div>
      </div>;
  }
}

function mapStateToProps(state) {
  const { recoverReducer } = state;
  const { isFetching, errorMessage } = recoverReducer;
  return {
    isFetching,
    errorMessage
  };
}

export default connect(mapStateToProps)(RecuperaPassword);


// WEBPACK FOOTER //
// ./src/Containers/RecuperaPassword.js